<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="part"><a id="page_1"></a><span href="#/OEBPS/toc#part01" id="part01" title="Link target outside of Sample">PART ONE</span></p>
<p class="center"><img alt="" height="42" src="OEBPS/images/flow.jpg" width="85"/></p>
<p class="part1"><span href="#/OEBPS/toc#part01" title="Link target outside of Sample"><em>Sovereigns in the Making</em>:</span></p>
<p class="part1"><span class="small">THE FORMATIVE YEARS</span> (1869-1901)<a id="page_2"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?77663be2